(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elixi-cart"]) return;
  try {
    
  function initializeElixiCart(scope) {
    scope.querySelectorAll('[data-elixi-cart]').forEach((cartSection) => {
      const form = cartSection.querySelector('form');
      if (!form || form.dataset.elixiInitialized) return;
      form.dataset.elixiInitialized = 'true';
      const checkout = form.querySelector('[name="checkout"]');
      const notice = form.querySelector('[data-bump-notice]');
      const help = form.querySelector('[data-checkout-help]');
      const updateState = () => {
        let hasFront = false;
        let hasBump = false;
        form.querySelectorAll('.elixi-cart-item').forEach((item) => {
          const quantity = Number(item.querySelector('[name="updates[]"]').value);
          if (quantity > 0 && item.dataset.frontOffer === 'true') hasFront = true;
          if (quantity > 0 && item.dataset.orderBump === 'true') hasBump = true;
        });
        const blocked = hasBump && !hasFront;
        checkout.disabled = blocked;
        notice.hidden = !blocked;
        help.hidden = !blocked;
        return blocked;
      };
      form.addEventListener('input', updateState);
      form.addEventListener('submit', (event) => {
        if (event.submitter?.name === 'checkout' && updateState()) event.preventDefault();
      });
      updateState();
    });
  }
  initializeElixiCart(document);
  document.addEventListener('shopify:section:load', (event) => initializeElixiCart(event.target.parentElement || document));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elixi-header"]) return;
  try {
    
  document.addEventListener('click',(event)=>{document.querySelectorAll('.elixi-header details[open]').forEach((item)=>{if(!item.contains(event.target)||event.target.closest('a'))item.open=false;});});
  document.addEventListener('keydown',(event)=>{
    if(event.key!=='Escape')return;
    document.querySelectorAll('.elixi-header details[open]').forEach((item)=>{item.open=false;item.querySelector('summary').focus();});
    document.querySelectorAll('.elixi-product-nav>a').forEach((item)=>{if(item.matches(':hover,:focus-visible'))item.setAttribute('data-preview-dismissed','');});
  });
  document.querySelectorAll('.elixi-product-nav>a').forEach((item)=>{
    ['pointerenter','pointerleave','focus','blur'].forEach((name)=>item.addEventListener(name,()=>item.removeAttribute('data-preview-dismissed')));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elixi-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elixi-home-carousel')) {
    customElements.define('elixi-home-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-home-carousel-track]');
        this.controls = this.querySelector('[data-home-carousel-controls]');
        if (!this.track || !this.controls) return;
        this.previous = this.controls.querySelector('[data-home-carousel-direction="-1"]');
        this.next = this.controls.querySelector('[data-home-carousel-direction="1"]');
        this.update = () => {
          const maximum = this.track.scrollWidth - this.track.clientWidth;
          const position = Math.abs(this.track.scrollLeft);
          this.controls.hidden = maximum < 3;
          this.previous.disabled = position < 3;
          this.next.disabled = position >= maximum - 3;
        };
        this.move = (direction) => {
          const first = this.track.firstElementChild;
          if (!first) return;
          const style = getComputedStyle(this.track);
          const distance = first.getBoundingClientRect().width + parseFloat(style.columnGap || 0);
          const rtl = style.direction === 'rtl' ? -1 : 1;
          this.track.scrollBy({left: direction * distance * rtl, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        };
        this.onClick = (event) => {
          const button = event.target.closest('[data-home-carousel-direction]');
          if (!button || button.disabled || !this.controls.contains(button)) return;
          this.move(Number(button.dataset.homeCarouselDirection));
        };
        this.onKey = (event) => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          } else {
            this.track.scrollTo({left: event.key === 'Home' ? 0 : this.track.scrollWidth * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
          }
        };
        this.track.addEventListener('scroll', this.update, {passive: true});
        this.track.addEventListener('keydown', this.onKey);
        this.controls.addEventListener('click', this.onClick);
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this.track);
        } else {
          window.addEventListener('resize', this.update);
        }
        this.update();
      }
      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.update);
        this.track?.removeEventListener('keydown', this.onKey);
        this.controls?.removeEventListener('click', this.onClick);
        this.resizeObserver?.disconnect();
        window.removeEventListener('resize', this.update);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elixi-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeMediaTrack = (section, track, thumbnails) => {
      const slides = Array.from(track.querySelectorAll('[data-gallery-slide]'));
      const items = Array.from(thumbnails.querySelectorAll('[data-gallery-thumbnail]'));
      const controls = section.querySelector('[data-gallery-controls]');
      const previous = controls.querySelector('[data-gallery-previous]');
      const next = controls.querySelector('[data-gallery-next]');
      const count = controls.querySelector('[data-gallery-count]');
      const mobile = window.matchMedia('(max-width: 749px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let active = 0;
      let pending = null;
      let settleTimer;
      let resizeFrame;
      const clamp = (index) => Math.max(0, Math.min(slides.length - 1, index));
      const loadPhoto = (index) => {
        const slide = slides[index];
        if (!slide) return;
        const image = slide.querySelector('img');
        if (image) image.loading = 'eager';
        const photo = slide.querySelector('[data-gallery-original-photo]');
        if (photo && !photo.hasAttribute('href')) photo.setAttribute('href', photo.dataset.galleryPhotoSrc);
      };
      track.querySelectorAll('[data-gallery-native-context="main"]').forEach((layer) => layer.removeAttribute('hidden'));
      const update = (index) => {
        active = clamp(index);
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === active);
          if (mobile.matches) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', String(i !== active));
        });
        items.forEach((item, i) => item.setAttribute('aria-pressed', String(i === active)));
        count.textContent = `${active + 1} / ${slides.length}`;
        previous.disabled = active === 0;
        next.disabled = active === slides.length - 1;
        [active - 1, active, active + 1].forEach(loadPhoto);
      };
      const offset = (index) => slides[index].offsetLeft - slides[0].offsetLeft;
      const nearest = () => slides.reduce((best, slide, index) => Math.abs(offset(index) - track.scrollLeft) < Math.abs(offset(best) - track.scrollLeft) ? index : best, 0);
      const settle = () => {
        if (!mobile.matches) return;
        pending = null;
        update(nearest());
      };
      const show = (index, smooth = true) => {
        const target = clamp(index);
        clearTimeout(settleTimer);
        pending = mobile.matches ? target : null;
        update(target);
        if (mobile.matches) {
          track.scrollTo({left: offset(target), behavior: smooth && !reducedMotion.matches ? 'smooth' : 'instant'});
          settleTimer = window.setTimeout(settle, 600);
        }
      };
      track.addEventListener('scroll', () => {
        if (!mobile.matches) return;
        if (pending === null) update(nearest());
        clearTimeout(settleTimer);
        settleTimer = window.setTimeout(settle, 140);
      }, {passive: true});
      track.addEventListener('pointerdown', () => { pending = null; clearTimeout(settleTimer); }, {passive: true});
      track.addEventListener('wheel', () => { pending = null; }, {passive: true});
      previous.addEventListener('click', () => show((pending ?? active) - 1));
      next.addEventListener('click', () => show((pending ?? active) + 1));
      thumbnails.addEventListener('click', (event) => {
        const item = event.target.closest('[data-gallery-thumbnail]');
        if (item) show(items.indexOf(item));
      });
      thumbnails.addEventListener('keydown', (event) => {
        const focused = event.target.closest('[data-gallery-thumbnail]');
        if (!focused) return;
        const index = items.indexOf(focused);
        const targets = {ArrowLeft: index - 1, ArrowRight: index + 1, ArrowUp: index - 4, ArrowDown: index + 4, Home: 0, End: slides.length - 1};
        if (!(event.key in targets)) return;
        event.preventDefault();
        show(targets[event.key]);
        items[active].focus({preventScroll: true});
      });
      section.querySelector('.elixi-product__gallery').addEventListener('keydown', (event) => {
        const targets = {ArrowLeft: active - 1, ArrowRight: active + 1, Home: 0, End: slides.length - 1};
        if (!(event.key in targets)) return;
        event.preventDefault();
        show(targets[event.key]);
      });
      const realign = () => {
        const selected = pending ?? active;
        clearTimeout(settleTimer);
        pending = null;
        cancelAnimationFrame(resizeFrame);
        resizeFrame = requestAnimationFrame(() => show(selected, false));
      };
      mobile.addEventListener('change', realign);
      new ResizeObserver(realign).observe(track);
      const photoObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => { if (entry.isIntersecting) loadPhoto(slides.indexOf(entry.target)); });
      }, {root: track, rootMargin: '0px 100%'});
      slides.forEach((slide) => photoObserver.observe(slide));
      thumbnails.hidden = false;
      controls.hidden = false;
      show(0, false);
    };
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-elixi-product], [data-elixi-eye-product], [data-elixi-sweet-product]').forEach((section) => {
        if (section.dataset.initialized === 'true') return;
        section.dataset.initialized = 'true';
        if (section.hasAttribute('data-elixi-eye-product') || section.hasAttribute('data-elixi-sweet-product')) {
          initializeMediaTrack(section, section.querySelector('[data-gallery-track]'), section.querySelector('[data-gallery-thumbnails]'));
          return;
        }
        const form = section.querySelector('.elixi-product__form');
        const bumpFieldset = section.querySelector('[data-bumps]');
        const error = section.querySelector('[data-error]');
        const buttons = Array.from(section.querySelectorAll('[data-add]'));
        const currency = new Intl.NumberFormat(section.dataset.locale, { style: 'currency', currency: section.dataset.currency });
        const galleryImage = section.querySelector('.elixi-product__image');
        const thumbnails = section.querySelector('[data-gallery-thumbnails]');
        const mediaTrack = section.querySelector('[data-gallery-track]');
        if (mediaTrack && thumbnails) initializeMediaTrack(section, mediaTrack, thumbnails);
        if (galleryImage && thumbnails && !mediaTrack) {
          thumbnails.hidden = false;
          const items = Array.from(thumbnails.querySelectorAll('[data-gallery-thumbnail]'));
          const panels = Array.from(section.querySelectorAll('[data-gallery-panel]'));
          const controls = section.querySelector('[data-gallery-controls]');
          const counts = Array.from(section.querySelectorAll('[data-gallery-count]'));
          const caption = section.querySelector('[data-gallery-caption]');
          const gallery = section.querySelector('.elixi-product__gallery');
          const zoom = section.querySelector('[data-gallery-zoom]');
          const dialog = section.querySelector('[data-gallery-dialog]');
          const zoomScroll = dialog?.querySelector('[data-gallery-zoom-scroll]');
          const zoomFrame = dialog?.querySelector('[data-gallery-zoom-frame]');
          const detail = dialog?.querySelector('[data-gallery-detail]');
          const nativeLayers = Array.from(section.querySelectorAll('[data-gallery-native-context="main"], [data-gallery-native-context="zoom"]'));
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          const loadOriginalPhoto = (layer) => {
            const photo = layer.querySelector('[data-gallery-original-photo]');
            if (photo && !photo.hasAttribute('href')) photo.setAttribute('href', photo.dataset.galleryPhotoSrc);
          };
          let active = 0;
          let detailed = false;
          let bodyOverflow = '';
          let pageScroll = {x: 0, y: 0};
          const setDetail = (value) => {
            detailed = value;
            if (!zoomFrame) return;
            zoomFrame.style.width = value ? `${Number(items[active].dataset.imageZoomWidth)}px` : '';
            zoomFrame.classList.toggle('is-detailed', value);
            if (detail) {
              detail.setAttribute('aria-pressed', String(value));
              detail.textContent = value ? detail.dataset.labelFit : detail.dataset.labelDetail;
            }
            if (zoomScroll) zoomScroll.scrollTo({top: 0, left: 0, behavior: 'instant'});
          };
          const syncZoom = () => {
            if (!dialog?.open) return;
            nativeLayers.filter((layer) => layer.dataset.galleryNativeContext === 'zoom' && !layer.hasAttribute('hidden')).forEach(loadOriginalPhoto);
            const image = dialog.querySelector('img');
            image.srcset = '';
            image.src = items[active].dataset.imageZoomSrc || galleryImage.src;
            image.alt = galleryImage.alt;
            setDetail(false);
          };
          const keepThumbnailVisible = (item) => {
            const vertical = getComputedStyle(thumbnails).flexDirection === 'column';
            const itemRect = item.getBoundingClientRect();
            const railRect = thumbnails.getBoundingClientRect();
            let delta = 0;
            if (vertical) {
              if (itemRect.top < railRect.top + 4) delta = itemRect.top - railRect.top - 4;
              else if (itemRect.bottom > railRect.bottom - 4) delta = itemRect.bottom - railRect.bottom + 4;
            } else {
              if (itemRect.left < railRect.left + 4) delta = itemRect.left - railRect.left - 4;
              else if (itemRect.right > railRect.right - 4) delta = itemRect.right - railRect.right + 4;
            }
            if (delta) thumbnails.scrollBy({[vertical ? 'top' : 'left']: delta, behavior: reducedMotion.matches ? 'instant' : 'smooth'});
          };
          const preloadNeighbors = () => {
            [-1, 1].forEach((offset) => {
              const index = (active + offset + items.length) % items.length;
              const item = items[index];
              if (item.dataset.panel || item.dataset.preloaded) return;
              item.dataset.preloaded = 'true';
              const image = new Image();
              image.sizes = galleryImage.sizes;
              image.srcset = item.dataset.imageSrcset || '';
              image.src = item.dataset.imageSrc;
              nativeLayers.filter((layer) => layer.dataset.galleryNativeContext === 'main' && Number(layer.dataset.galleryNativeSlide) === index + 1).forEach(loadOriginalPhoto);
            });
          };
          const show = (index) => {
            active = (index + items.length) % items.length;
            const item = items[active];
            const panel = item.dataset.panel;
            galleryImage.hidden = Boolean(panel);
            nativeLayers.forEach((layer) => {
              const visible = !panel && Number(layer.dataset.galleryNativeSlide) === active + 1;
              layer.toggleAttribute('hidden', !visible);
              if (visible && layer.dataset.galleryNativeContext === 'main') loadOriginalPhoto(layer);
            });
            panels.forEach((node) => { node.hidden = node.dataset.galleryPanel !== panel; });
            if (!panel) {
              galleryImage.srcset = item.dataset.imageSrcset || '';
              galleryImage.src = item.dataset.imageSrc;
              galleryImage.alt = item.dataset.imageAlt;
              galleryImage.style.objectFit = item.dataset.imageFit || 'contain';
            }
            items.forEach((node) => node.setAttribute('aria-pressed', String(node === item)));
            if (zoom) zoom.hidden = Boolean(panel);
            counts.forEach((count) => { count.textContent = `${active + 1} / ${items.length}`; });
            if (caption) caption.textContent = item.getAttribute('aria-label');
            keepThumbnailVisible(item);
            syncZoom();
            preloadNeighbors();
          };
          thumbnails.addEventListener('click', (event) => {
            const item = event.target.closest('[data-gallery-thumbnail]');
            if (item) show(items.indexOf(item));
          });
          thumbnails.addEventListener('keydown', (event) => {
            const focused = event.target.closest('[data-gallery-thumbnail]');
            if (!focused) return;
            const index = items.indexOf(focused);
            const targets = { ArrowLeft: index - 1, ArrowUp: index - 1, ArrowRight: index + 1, ArrowDown: index + 1, Home: 0, End: items.length - 1 };
            if (!(event.key in targets)) return;
            event.preventDefault();
            show(targets[event.key]);
            items[active].focus({ preventScroll: true });
          });
          const galleryKeys = (event) => {
            if (detailed && dialog?.open) return;
            if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
              event.preventDefault();
              show(active + (event.key === 'ArrowLeft' ? -1 : 1));
            }
          };
          gallery.addEventListener('keydown', galleryKeys);
          dialog?.addEventListener('keydown', galleryKeys);
          if (controls) controls.hidden = false;
          section.querySelectorAll('[data-gallery-previous]').forEach((button) => button.addEventListener('click', () => show(active - 1)));
          section.querySelectorAll('[data-gallery-next]').forEach((button) => button.addEventListener('click', () => show(active + 1)));
          const bindSwipe = (surface) => {
            if (!surface) return;
            let start = null;
            surface.addEventListener('pointerdown', (event) => {
              if (!event.isPrimary || event.button !== 0 || detailed && dialog?.open || event.target.closest('button')) return;
              start = {x: event.clientX, y: event.clientY, id: event.pointerId};
              surface.setPointerCapture(event.pointerId);
            });
            surface.addEventListener('pointerup', (event) => {
              if (!start || event.pointerId !== start.id) return;
              const dx = event.clientX - start.x;
              const dy = event.clientY - start.y;
              start = null;
              if (Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy) * 1.4) show(active + (dx < 0 ? 1 : -1));
            });
            surface.addEventListener('pointercancel', () => { start = null; });
            surface.addEventListener('dragstart', (event) => event.preventDefault());
          };
          bindSwipe(gallery);
          bindSwipe(zoomScroll);
          if (zoom && dialog) {
            zoom.addEventListener('click', () => {
              pageScroll = {x: window.scrollX, y: window.scrollY};
              bodyOverflow = document.body.style.overflow;
              document.body.style.overflow = 'hidden';
              dialog.showModal();
              syncZoom();
              window.scrollTo({left: pageScroll.x, top: pageScroll.y, behavior: 'instant'});
            });
            detail?.addEventListener('click', () => setDetail(!detailed));
            dialog.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
            dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
            dialog.addEventListener('close', () => {
              document.body.style.overflow = bodyOverflow;
              setDetail(false);
              zoom.focus({preventScroll: true});
              window.scrollTo({left: pageScroll.x, top: pageScroll.y, behavior: 'instant'});
            });
          }
          show(0);
        }
        let pending = false;
        if (bumpFieldset) bumpFieldset.hidden = false;
        const selection = () => {
          const pack = form.querySelector('input[name="id"]:checked');
          const bumps = Array.from(form.querySelectorAll('[data-bump]:checked'));
          const available = pack?.dataset.available === 'true' && bumps.every((bump) => bump.dataset.available === 'true') && !form.hasAttribute('data-preview');
          return { pack, bumps, available };
        };
        const update = () => {
          const { pack, bumps, available } = selection();
          if (!pack) return;
          const shipping = Number(pack.dataset.shipping);
          const total = Number(pack.dataset.price) + shipping + bumps.reduce((sum, bump) => sum + Number(bump.dataset.price), 0);
          section.querySelectorAll('[data-total]').forEach((item) => { item.textContent = currency.format(total / 100); });
          section.querySelectorAll('[data-shipping]').forEach((item) => {
            item.textContent = shipping === 0 ? section.dataset.labelFree : `${currency.format(shipping / 100)} ${section.dataset.labelShipping}`;
          });
          section.querySelectorAll('[data-selected-pack]').forEach((item) => { item.textContent = `${pack.dataset.pack}-${section.dataset.labelUnits}`; });
          buttons.forEach((button) => {
            button.disabled = pending || !available;
            button.setAttribute('aria-busy', String(pending));
            button.querySelector('[data-button-label]').textContent = pending ? section.dataset.labelPending : available ? section.dataset.labelAdd : section.dataset.labelSoon;
          });
        };
        form.addEventListener('change', () => {
          error.hidden = true;
          update();
        });
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const { pack, bumps, available } = selection();
          if (pending || !available || !pack) return;
          pending = true;
          error.hidden = true;
          update();
          try {
            const items = [{ id: Number(pack.value), quantity: 1 }, ...bumps.map((bump) => ({ id: Number(bump.dataset.variant), quantity: 1 }))];
            const response = await fetch(`${section.dataset.cartAddUrl}.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items })
            });
            const result = await response.json();
            if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : section.dataset.labelError);
            window.location.assign(section.dataset.cartUrl);
          } catch (problem) {
            error.textContent = problem.message || section.dataset.labelError;
            error.hidden = false;
            pending = false;
            update();
          }
        });
        update();
        const sticky = section.querySelector('[data-sticky]');
        const mainButton = form.querySelector('[data-add]');
        if (sticky && mainButton && 'IntersectionObserver' in window) {
          const observer = new IntersectionObserver(([entry]) => {
            sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom >= 0;
          });
          observer.observe(mainButton);
        }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
    else initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
